module.exports = "/_next/static/images/6fb2006058f10eede9806d7c53ed627f-safe.svg";